import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconGavel(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.517 11.198 20.87 9.55a1.649 1.649 0 0 0-2.147-.158l-5.115-5.114a1.649 1.649 0 0 0-.156-2.147L11.802.483a1.649 1.649 0 0 0-2.331 0L2.877 7.076a1.648 1.648 0 0 0 0 2.332l1.649 1.648a1.649 1.649 0 0 0 2.146.157l.739.738-6.736 6.736a2.575 2.575 0 0 0 3.639 3.638l6.734-6.735.739.737a1.648 1.648 0 0 0 .157 2.147l1.648 1.649a1.649 1.649 0 0 0 2.332 0l6.593-6.594a1.65 1.65 0 0 0 0-2.331ZM5.691 9.891 4.043 8.242l6.593-6.593 1.649 1.648L5.69 9.891ZM3.148 21.159a.927.927 0 0 1-1.307 0 .927.927 0 0 1 0-1.306l6.735-6.736 1.307 1.307-6.735 6.735Zm4.707-11.097 4.6-4.601 5.084 5.083-4.6 4.6-5.084-5.082Zm6.902 8.894-1.648-1.648.412-.412 5.77-5.769.411-.412 1.649 1.648-6.594 6.593Z"
  }));
}
IconGavel.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconGavel.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconGavel as default };
